module.exports = __webpack_public_path__ + "img/T2D_rc_0.ad84cdac.png";